import { Button, Flex, SvgIcon, TextInput, Tooltip } from '@volue/wave-react';
import type { KeyboardEvent } from 'react';
import React, { useState } from 'react';

import { useActions, useAppState } from '@/overmind';

export function FeatureSearchInput() {
  const [assetName, setAssetName] = useState('');

  const searchState = useAppState().arcgis.featureSearch.current;
  const { searchForFeatures, resetFeatureSearchState } =
    useActions().arcgis.featureSearch;

  const isSearchInputEmpty = assetName === '';

  const search = () => {
    if (isSearchInputEmpty) {
      return;
    }

    searchForFeatures({
      searchText: assetName
    });
  };

  const reset = () => {
    setAssetName('');
    resetFeatureSearchState();
  };

  const onKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      search();
    } else if (searchState !== 'NOT_LOADED') {
      resetFeatureSearchState();
    }
  };

  return (
    <Flex flow="column" gap="spacingXs">
      <TextInput
        placeholder="Search"
        value={assetName}
        onChange={event => setAssetName(event.target.value)}
        onKeyDown={onKeyDown}
        leadingVisual={
          <Tooltip content={'Search'}>
            <Button
              withLoneIcon
              size="tiny"
              variant="ghost"
              onClick={search}
              disabled={isSearchInputEmpty}
            >
              <SvgIcon
                iconName="search"
                css={{ color: isSearchInputEmpty ? undefined : '$colorBlack' }}
              />
            </Button>
          </Tooltip>
        }
        trailingVisual={
          <>
            {!isSearchInputEmpty && (
              <Tooltip content={'Clear search'}>
                <Button
                  withLoneIcon
                  size="tiny"
                  variant="ghost"
                  onClick={reset}
                >
                  <SvgIcon iconName="close" css={{ color: '$colorBlack' }} />
                </Button>
              </Tooltip>
            )}
          </>
        }
      />
    </Flex>
  );
}
